import { render, staticRenderFns } from "./SideTagsHomePage.vue?vue&type=template&id=767d06ea&scoped=true&"
import script from "./SideTagsHomePage.vue?vue&type=script&lang=js&"
export * from "./SideTagsHomePage.vue?vue&type=script&lang=js&"
import style0 from "./SideTagsHomePage.vue?vue&type=style&index=0&id=767d06ea&lang=less&scoped=true&"
import style1 from "./SideTagsHomePage.vue?vue&type=style&index=1&id=767d06ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767d06ea",
  null
  
)

export default component.exports